module.exports = __webpack_public_path__ + "assets_app/img/logo-kickstart.4ecc3b77.png";